const ControlInput = ({ inputRef, ...rest }) => {
  return <div ref={inputRef} {...rest} />;
};

export default ControlInput;
